module.exports = __webpack_public_path__ + "static/media/lock-open.016eee24.svg";